module.exports = __webpack_public_path__ + "img/video-form.7c7c7053.svg";